export default __webpack_public_path__ + "static/media/pp-b-8.2f594f86.svg";